<template>
    <div>
        <h5>既往病史</h5>
        <div class="card">
            <div class="flex">
                <el-form-item label="严重皮肤病" label-width="130px">
                    <el-radio-group v-model="formData.skinDisease">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="糖尿病" label-width="130px">
                    <el-radio-group v-model="formData.diabetes">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="自身免疫病" label-width="130px">
                    <el-radio-group v-model="formData.autoimmuneDisease">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item label="凝血功能障碍" label-width="130px">
                    <el-radio-group v-model="formData.coagulationDisorders">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="药物/食物过敏史" label-width="130px">
                    <el-radio-group v-model="formData.allergyHistory">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否备孕" label-width="130px">
                    <el-radio-group v-model="formData.preparationPregnant">
                        <el-radio :label="'1'">有</el-radio>
                        <el-radio :label="'0'">无</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <el-form-item label="其他" class="double">
                <el-input v-model.trim="formData.medicalHistoryOther" style="width:95%;" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="查体" class="double">
                <el-input v-model.trim="formData.physicalExamination" style="width:95%;" placeholder="请输入查体"></el-input>
            </el-form-item>
        </div>
        <h5>诊断</h5>
        <div class="card">
            <el-form-item label="诊断" class="double">
                <el-checkbox-group @change="testSX" v-model="formData.diagnosisNo">
                    <el-checkbox v-for="(item,index) in skinDiagnosis" :key="index" :label="item.id">
                        <span>{{item.name}}</span>
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="其他" class="double">
                <el-input v-model.trim="formData.diagnosisOther" style="width:95%;" placeholder="请输入其他诊断"></el-input>
            </el-form-item>
        </div>

    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
    props: ['formData'],
    computed: {
        ...mapState(['skinDiagnosis',]),
    },
    data() {
        return {

        }
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
    }
}
</script>
<style scoped>
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.flex {
  display: flex;
  align-items: center;
}
.double >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
</style>


